import { cloudFunction } from 'services/parse';

export const createBanner = (data: Record<string, any>) => {
  return cloudFunction('createBanner', data);
};

export const fetchAllActiveBanners = () => {
  return cloudFunction('fetchAllActiveBanners', {});
};

export const fetchAllBanners = () => {
  return cloudFunction('fetchAllBanners', {});
};

export const fetchBannerDetails = (id: string) => {
  return cloudFunction('fetchBannerDetails', { id });
};

export const toggleBannerActiveStatus = (id: string) => {
  return cloudFunction('toggleBannerActiveStatus', { id });
};

export const updateBanner = (data: Record<string, any>) => {
  return cloudFunction('updateBanner', data);
};

export const fetchUrlMetadata = (url: string) => {
  return cloudFunction('fetchUrlMetadata', { url });
};